export default "__VITE_ASSET__CmHeWyWL__"